import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicLayout from '../../components/layout/PublicLayout';
import { Compass, Home, Package, LifeBuoy, LogIn } from 'lucide-react';

const links = [
  { label: 'Home', path: '/', icon: Home },
  { label: 'Products', path: '/products', icon: Package },
  { label: 'Help', path: '/help', icon: LifeBuoy },
  { label: 'Login', path: '/login', icon: LogIn },
];

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <PublicLayout title="Page Not Found" description="The page you are looking for could not be found.">
      <section className="max-w-2xl mx-auto px-5 lg:px-8 py-24 text-center">
        <div className="w-16 h-16 mx-auto rounded-2xl flex items-center justify-center text-white mb-6" style={{ background: 'linear-gradient(135deg,#1E3A5F,#2D8CFF)' }}>
          <Compass className="w-8 h-8" />
        </div>
        <h1 className="text-4xl sm:text-5xl font-bold">Page not found</h1>
        <p className="mt-4 opacity-70">The page you're looking for doesn't exist or may have moved. Try one of these instead:</p>
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="notfound-links">
          {links.map((l) => (
            <button key={l.path} onClick={() => navigate(l.path)}
              className="glass-card p-4 rounded-xl flex flex-col items-center gap-2 transition-transform hover:scale-[1.03]">
              <l.icon className="w-5 h-5 text-[#2D8CFF]" />
              <span className="text-sm font-medium">{l.label}</span>
            </button>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
};

export default NotFound;
